export default "__VITE_ASSET__BzlYKb3X__"